<template>
  <v-breadcrumbs
    v-if="items.length > 1"
    :items="items"
    class="breadcrumbs pa-0 mb-2"
    density="compact"
  >
    <template #prepend>
      <v-icon size="16" class="mr-1">mdi-home</v-icon>
    </template>
    <template #divider>
      <v-icon size="14">mdi-chevron-right</v-icon>
    </template>
    <template #item="{ item }">
      <v-breadcrumbs-item
        :to="item.to"
        :disabled="item.disabled"
        class="text-caption"
      >
        {{ item.title }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

export default {
  name: 'AppBreadcrumbs',
  setup() {
    const route = useRoute()

    const items = computed(() => {
      const crumbs = [{ title: 'Inicio', to: { name: 'dashboard' }, disabled: false }]

      // Construir breadcrumbs desde la ruta matched
      const matched = route.matched.filter(r => r.meta?.title)

      matched.forEach((record, index) => {
        const isLast = index === matched.length - 1
        crumbs.push({
          title: record.meta.title,
          to: isLast ? undefined : { name: record.name },
          disabled: isLast
        })
      })

      return crumbs
    })

    return { items }
  }
}
</script>

<style scoped>
.breadcrumbs {
  min-height: auto;
}

.breadcrumbs :deep(.v-breadcrumbs-item) {
  font-size: 12px;
}

.breadcrumbs :deep(.v-breadcrumbs-item--disabled) {
  opacity: 0.7;
}
</style>
